import api from '../../Auth/api';
import { createEffect, createStore } from 'effector';

export type ServicePageData = {
    id: number;
    [key: string]: any;
};

export const $servicePage = createStore<{ data: ServicePageData } | null>(null);

export const getServicePageFx = createEffect(async (id: number) => {
    return await api.get(`paid-service/get?id=${id}`);
});

export const syncServiceDocumentFx = createEffect(async (id: number) => {
    return await api.post('paid-service/document-sync', { id });
});

$servicePage.on(getServicePageFx, (state, id) => {
    // Открывается другая услуга — не показываем данные предыдущей,
    // пока не загрузятся актуальные
    if (state?.data?.id !== id) {
        return null;
    }

    return state;
});

$servicePage.on(getServicePageFx.done, (_, { result }) => {
    return {
        data: result.data.data
    };
});

$servicePage.on(getServicePageFx.fail, (state) => state);
